// Allowlist of events to mirror to Amplitude.
// Only these will be forwarded; extend carefully to avoid noise.
import { EventName } from 'utils/hooks/useTrackEvent/types';

export const AMPLITUDE_EVENT_ALLOWLIST: Set<EventName> = new Set([
  'teacher_login',
  'test_page_access',
  'learning_path_report_access',
  'evolution_report_page_access',
  'grade_and_proficiency_level_card_click',
  'cognitive_axes_saeb_card_click',
  'student_engagement_card_click',
  'click_on_test_type_tab',
  'reviewed_composition_access',
  'learning_path_in_progress_composition_access',
  'composition_review_edited',
  'learning_path_BNCC_skills_button_click',
  'learning_path_access_student_list_button_click',
  'learning_path_access_engagement_button_click',
  'reopen_test_button_click',
  'home_page_access',
  'baixo_engajamento_click',
  'bom_desempenho_click',
  'com_dificuldades_click',
  'learning_path_quick_access_click',
  'create_learning_path_click',
  'redirect_to_evolution_report_click',
  'reminder_click',
  'redirect_to_support_material_click',
  'home_modal_filters',
  'redirect_to_learning_path_report_click',
  'learning_path_list_page_filters',
  'learning_path_list_page_access',
  'teacher_support_material_click',
  'student_support_material_click',
  'learning_path_card_expanded',
  'redirect_to_rewrite_report',
  'redirect_to_learning_path_report',
  'learning_path_report_bncc_skills_click',
  'learning_path_report_theme_click',
  'learning_path_report_questionnaire_content_click',
  'learning_path_report_open_steps_modal_click',
  'learning_path_report_composition_details_click',
  'learning_path_report_indicators_click',
  'learning_path_report_student_performance_filters',
  'write_support_material_click',
  'questionnaire_support_material_click',
  'learning_path_report_write_tab_click',
  'learning_path_report_questionnaire_tab_click',
  'learning_path_report_rewrite_tab_click',
  'learning_path_report_low_performance_write_click',
  'learning_path_report_low_performance_questionnaire_click',
]);

export function isEventAllowedForAmplitude(eventName: EventName): boolean {
  return AMPLITUDE_EVENT_ALLOWLIST.has(eventName);
}
